export default __webpack_public_path__ + "static/media/photo--lg--namrata-2.ad222eb0.jpg";